import React from 'react';
import { Helmet } from 'react-helmet';

const SEOSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://beauclean33.fr",
    "name": "BeauClean",
    "image": "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/9ya7cj5m_414487052_122099686172174913_3735285075994030322_n.jpg",
    "logo": "https://customer-assets.emergentagent.com/job_car-detailing-pro-13/artifacts/9ya7cj5m_414487052_122099686172174913_3735285075994030322_n.jpg",
    "url": "https://beauclean33.fr",
    "telephone": "+33665976864",
    "priceRange": "29€-129€",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Service à domicile",
      "addressLocality": "Bordeaux",
      "postalCode": "33000",
      "addressRegion": "Nouvelle-Aquitaine",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 44.837789,
      "longitude": -0.579180
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 44.837789,
        "longitude": -0.579180
      },
      "geoRadius": "40000"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de nettoyage",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Intérieur Automobile - L'Essentiel",
            "description": "Nettoyage intérieur express: aspiration, dépoussiérage, plastiques et vitres intérieures",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "49",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Automobile - Le Shampoing",
            "description": "Nettoyage en profondeur avec shampoing des sièges et textiles",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "89",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Automobile Premium",
            "description": "Prestation complète pour véhicules très sales avec traitement poussé",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "129",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Canapé 2 Places",
            "description": "Nettoyage professionnel canapé avec shampoing et désinfection",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "59",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Matelas 2 Places",
            "description": "Hygiénisation complète avec élimination acariens et désinfection",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "79",
          "priceCurrency": "EUR"
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Nettoyage Tapis",
            "description": "Nettoyage tapis professionnel à domicile",
            "provider": {
              "@type": "LocalBusiness",
              "name": "BeauClean"
            }
          },
          "price": "29",
          "priceCurrency": "EUR"
        }
      ]
    },
    "sameAs": [
      "https://www.facebook.com/beauclean",
      "https://www.instagram.com/beauclean"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default SEOSchema;
